import {required} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrPerfTablolarDetayParametreHedefTanim = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrPerfTablolarDetayParametreHedefTanimData:{
            Id: "",
            Hedefadi: "",
            Deleted: false,
            Ustid: null,
            Sira: 0
          },
        FormDataType:{ 
          Hedefadi:{FieldName:"Hedefadi",Field:"input",FieldTitle:this.$t('StrPerfTablolarDetayParametreHedefTanim.AddEdit.Hedefadi'),FieldType:"text"},
          Sira:{FieldName:"SiraNo",Field:"input",FieldTitle:this.$t('StrPerfTablolarDetayParametreHedefTanim.Table.Sira'),FieldType:"number"},
        },
   
      }
    },
    validations:{ 
        FormData: {
            Hedefadi: { required },       
            Ustid: {},
            Sira: {}

        } 
    },


    created(){ 

      
    }


}
export default StrPerfTablolarDetayParametreHedefTanim